<template>
    <div class="aspect-square gradient flex items-center justify-center">
        <div>
            <img src="../../images/spinner.svg" alt="spinner" width="78" height="78" class="mx-auto">
            <p class="font-bi-text-bold text-2xl text-bi-dark-green text-center">{{ $t('generating') }}</p>
        </div>
    </div>
</template>

<style scoped>
.gradient {
    background-image: radial-gradient(circle, #ffffff 0%, rgba(255, 255, 255, 0) 44%);
}
</style>
